import React from 'react';
import Seo from './Seo';

const PrivacyPolicy = () => {
  return (
    <div className="page pt-32">
      <Seo
        title="Privacy Policy | CompressImages.org"
        description="Read how CompressImages.org handles image files, analytics data, cookies, and advertising disclosures."
        path="/privacy-policy"
      />

      <div className="policy-wrap">
      <h1>Privacy Policy</h1>
      <div className="policy-date">Last updated: May 25, 2026</div>

      <div className="policy-body">
      <p>
        CompressImages.org is a free browser-based image compression tool. This
        policy explains what information is processed when you use the website.
      </p>

      <h2>Image Processing</h2>
      <p>
        Uploaded images are processed locally in your browser with canvas APIs.
        We do not upload, store, review, or share your image files on our
        servers.
      </p>

      <h2>Information We Collect</h2>
      <p>
        The website may receive standard technical data such as IP address,
        browser type, device type, referring page, pages visited, and approximate
        time of visit through hosting, analytics, and advertising services. If
        you contact us by email, we use your email address only to respond.
      </p>

      <h2>Cookies, Analytics, and Advertising</h2>
      <p>
        We use Vercel Analytics to understand aggregate website performance and
        traffic. We also use Google AdSense. Google and its partners may use
        cookies, web beacons, IP addresses, or similar identifiers to serve,
        measure, and personalize ads where allowed by law.
      </p>
      <p>
        You can learn how Google uses data from partner sites at{' '}
        <a
          href="https://policies.google.com/technologies/partner-sites"
          rel="noopener noreferrer"
          target="_blank"
        >
          Google&apos;s partner sites policy
        </a>
        . You can manage ad personalization at{' '}
        <a
          href="https://adssettings.google.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Google Ad Settings
        </a>
        .
      </p>

      <h2>How We Use Information</h2>
      <ul>
        <li>To operate, secure, and improve the website.</li>
        <li>To measure aggregate usage and performance.</li>
        <li>To display advertising that helps keep the tool free.</li>
        <li>To respond to messages sent to our contact email.</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>
        We do not sell personal information. Limited technical data may be
        processed by service providers such as Vercel and Google when they
        provide hosting, analytics, or advertising services.
      </p>

      <h2>Your Choices</h2>
      <p>
        You can block or delete cookies in your browser settings. Some features
        or ads may work differently when cookies are disabled. Users in regions
        that require consent may be shown additional consent controls.
      </p>

      <h2>Children</h2>
      <p>
        This website is not directed to children under 13, and we do not
        knowingly collect personal information from children.
      </p>

      <h2>Contact Us</h2>
      <p>
        For privacy questions, email{' '}
        <a href="mailto:contact@compressimages.org">contact@compressimages.org</a>.
      </p>
      </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
